import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Swiper from '../../../../components/swiper/autowidth'

const Tag = props => {
    useStyles(classes)
    const { tag, selectedTag, onTag } = props

    const handleClick = (tag) =>{
        if (window.GeekoSensors) {
            window.GeekoSensors.Track('ClogTabClick', {
                tab:tag?.value
            })
        }

        onTag(tag);
    }

    return <span data-tag={`${selectedTag}`} onClick={e => handleClick(tag)} className={`${classes.Tag} ${tag?.value === selectedTag ? classes.Selected:''}`} dangerouslySetInnerHTML={{ __html: tag?.label }} />
}

export default props => {
    useStyles(classes)
    const { tags, selectedTag, onTag } = props
    return <Swiper className={classes.Tags} options={{
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        spaceBetween: 20,
    }} items={tags} render={tag => {
        return <Tag onTag={onTag} tag={tag} selectedTag={selectedTag}/>
    }} />
}